<div class="form-field__text-label"></div>

<button
  type="button"
  [disabled]="isDisabled"
  class="form-button blue"
  (click)="onButtonClick()"
>
  {{ field.label || '' | translateInline }}
</button>
